export default __webpack_public_path__ + "static/media/Standard08.d7c29d72.png";